module.exports = __webpack_public_path__ + "img/icon_overtime_3.5dbfcc39.svg";